module.exports = __webpack_public_path__ + "static/media/4thSlide.4533e659.mp3";